import classNames from "classnames";

import { RobotoSwitch } from "@/shared/components/RobotoSwitch";
import { actions, useVizDispatch } from "@/shared/state/visualization";

import sectionStyles from "../SettingsSection.module.css";

interface ShowPlayheadToggleProps {
  panelId: string;
  showPlayhead: boolean;
}

export function ShowPlayheadToggle({
  panelId,
  showPlayhead,
}: ShowPlayheadToggleProps) {
  const dispatch = useVizDispatch();

  const onShowPlayheadChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      actions.setPlotPanelConfig(panelId, {
        showPlayhead: event.target.checked,
      }),
    );
  };

  return (
    <label
      className={classNames(sectionStyles.setting, sectionStyles.toggleRow)}
    >
      Show playhead
      <RobotoSwitch
        checked={showPlayhead}
        onChange={onShowPlayheadChange}
        color="success"
      />
    </label>
  );
}
